import _asyncToGenerator from "C:/Users/Marie/Desktop/2022/april/meh/my-gatsby-site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "C:\\Users\\Marie\\Desktop\\2022\\april\\meh\\my-gatsby-site\\node_modules\\@babel\\runtime\\regenerator\\index.js";
export var _vegalite;
export var _vega;

var _opt; // TODO: validation


function options() {
  var opt = Object.assign({}, _opt);

  for (var _len = arguments.length, viewopt = new Array(_len), _key = 0; _key < _len; _key++) {
    viewopt[_key] = arguments[_key];
  }

  opt.view = Object.assign.apply(Object, [{}, _opt.view].concat(viewopt));

  if (opt.view.spec) {
    opt.spec = opt.view.spec;
    delete opt.view.spec;
  }

  return opt;
}

function element() {
  return typeof document === 'undefined' ? undefined : document.createElement('div');
}

function createSpec(self) {
  var major = _vegalite ? _vegalite.version.split('.')[0] : '5';
  return Object.assign({
    $schema: "https://vega.github.io/schema/vega-lite/v".concat(major, ".json")
  }, self.toObject());
}

function createView(self, opt) {
  if (!_vegalite || !_vega) {
    throw Error('Vega / Vega-Lite not registered. Use the "register" method.');
  }

  var spec = _vegalite.compile(opt.spec || createSpec(self), opt.config),
      view = new _vega.View(_vega.parse(spec.spec), opt.view);

  if (opt.init) opt.init(view);
  return view;
}

export function render(_x) {
  return _render.apply(this, arguments);
}

function _render() {
  _render = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(opt) {
    var view, div;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            opt = options({
              container: opt && opt.container || element()
            }, opt);
            _context.next = 3;
            return createView(this, opt).runAsync();

          case 3:
            view = _context.sent;
            div = view.container() || {};
            div.value = view;
            return _context.abrupt("return", div);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));
  return _render.apply(this, arguments);
}

export function toView(opt) {
  return createView(this, options(opt));
}
export function toSpec() {
  return createSpec(this);
}
export function toString(space) {
  return JSON.stringify(createSpec(this), null, space);
}
export function register(vega, vegalite, options) {
  _vegalite = vegalite;
  _vega = vega;
  _opt = options || {};
  return this;
}